<!-- =========================================================================================
	File Name: TakeOrder2.vue
	Description: Order taker
	----------------------------------------------------------------------------------------
  Item Name: deltaPOS Orders
  Author: acentoNET
  Author URL: https://acentoNET.com
========================================================================================== -->

<template>
  <div id="deltapos-new-order">
    <form-wizard
      ref="newOrderWizard"
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      :hide-buttons="true">

      <!-- Customer's data -->
      <tab-content title="Datos del cliente" icon="feather icon-user" class="mb-5">
        <div class="vx-row">
          <div class="vx-col lg:w-2/3 w-full relative">
            <vx-card class="list-view-item mb-base overflow-hidden ml-2">
              <div class="w-full mb-2">
                <ejs-textbox floatLabelType="Auto" placeholder="Busque cliente o seleccione Consumidor final" showClearButton=true :change="customerNameChanged" @keyup.enter="customerNameChanged"/>
              </div>
              <div class="w-full">
                <ejs-grid
                  height="400px"
                  ref="gridCustomers"
                  :dataSource="persons"
                  locale='es-GT'
                  :allowPaging="true"
                  :pageSettings='pageSettings'
                  :allowSorting='true'
                  :sortSettings='sortOptions'
                  :toolbarOptions="toolbarOptions"
                  :rowSelected="customerRowSelected"
                >
                  <e-columns>
                    <e-column field="id" :visible=false headerText="ID" :isPrimaryKey="true"/>
                    <e-column field="name" headerText="Nombre"/>
                    <e-column field="vat" headerText="NIT" width="200"/>
                    <e-column field="dpi" :headerText="dpiLabel" width="150"/>
                  </e-columns>
                </ejs-grid>
              </div>
            </vx-card>
            >
          </div>
          <div class="vx-col lg:w-1/3 w-full relative">
            <vx-card class="list-view-item mb-base overflow-hidden mr-2">
              <div class="w-full mb-1 flex justify-between">
                <vx-tooltip position="top" text="Cerrar toma de órdenes y regresar a inicio">
                  <vs-button color="success" icon-pack="feather" icon="icon-home" class="mr-1" :to="{name: 'home'}"></vs-button>
                </vx-tooltip>
                <vx-tooltip position="top" text="Continuar con cliente seleccionado">
                  <vs-button class="mt-1 ml-2" size="small" icon-pack="feather" icon="icon-arrow-right-circle" @click.prevent="nextWithCustomer" v-show="customerInfo.id > 0">CONTINUAR</vs-button>
                </vx-tooltip>
              </div>
              <div v-show="customerSelected || editingCustomer">
                <div class="w-full mb-1">
                  <ejs-textbox floatLabelType="Auto" placeholder="Nombre" v-model="customerInfo.name"/>
                </div>
                <div class="w-full mb-1">
                  <ejs-textbox floatLabelType="Auto" placeholder="NIT" v-model="customerInfo.vat"/>
                </div>
                <div class="w-full mb-1">
                  <ejs-textbox floatLabelType="Auto" placeholder="Dirección" v-model="customerInfo.address"/>
                </div>
                <div class="w-full mb-1">
                  <ejs-textbox floatLabelType="Auto" placeholder="Departamento" v-model="customerInfo.state"/>
                </div>
                <div class="w-full mb-1">
                  <ejs-textbox floatLabelType="Auto" placeholder="Teléfono" v-model="customerInfo.phones"/>
                </div>
                <div class="w-full mb-1">
                  <ejs-textbox floatLabelType="Auto" placeholder="Correo electrónico" v-model="customerInfo.email"/>
                </div>
                <div class="w-full mb-1">
                  <ejs-textbox floatLabelType="Auto" :placeholder="dpiLabel" v-model="customerInfo.dpi"/>
                </div>
                <div class="w-full mb-1" v-if="customerExtra1 != ''">
                  <ejs-textbox floatLabelType="Auto" :placeholder="customerExtra1" v-model="customerInfo.extra1"/>
                </div>
                <div class="w-full mb-1" v-if="customerExtra2 != ''">
                  <ejs-textbox floatLabelType="Auto" :placeholder="customerExtra2" v-model="customerInfo.extra2"/>
                </div>
                <div class="w-full mb-1" v-if="customerExtra3 != ''">
                  <ejs-textbox floatLabelType="Auto" :placeholder="customerExtra3" v-model="customerInfo.extra3"/>
                </div>
                <div class="w-full mb-1" v-if="customerExtra4 != ''">
                  <ejs-textbox floatLabelType="Auto" :placeholder="customerExtra4" v-model="customerInfo.extra4"/>
                </div>
                <div class="w-full mb-1" v-if="customerExtra5 != ''">
                  <ejs-textbox floatLabelType="Auto" :placeholder="customerExtra5" v-model="customerInfo.extra5"/>
                </div>
                <div class="w-full mb-1">
                  <label style="font-size: smaller;">Tipo de cliente</label><br/>
                  <ejs-dropdownlist highlight=true :dataSource="customerTypes" :fields="{text: 'value', value: 'code'}" v-model="customerInfo.type"></ejs-dropdownlist>
                </div>
                <div class="w-full mb-1">
                  <label style="font-size: smaller;">Tipo de documento</label><br/>
                  <ejs-dropdownlist highlight=true :dataSource="documentTypes" :fields="{text: 'name', value: 'code'}" v-model="selectedDocumentType"></ejs-dropdownlist>
                </div>
              </div>
              <div class="w-full mb-1 flex justify-between">
                <vs-button class="mt-1 mr-2" size="small" icon-pack="feather" icon="icon-x" type="border" @click.prevent="newCustomer" v-show="!editingCustomer">NUEVO CLIENTE</vs-button>
                <vs-button class="mt-1 mr-2" size="small" icon-pack="feather" icon="icon-save" @click.prevent="saveCustomer" v-show="editingCustomer">GUARDAR</vs-button>
                <vs-button class="mt-1 mr-2" size="small" icon-pack="feather" icon="icon-cancel" type="border" color="danger" @click.prevent="cancelCustomerEditing" v-show="editingCustomer">CANCELAR</vs-button>
                <vs-spacer v-show="editingCustomer"/>
                <vx-tooltip position="top" text="Continuar como consumidor final">
                  <vs-button class="mt-1 ml-2" size="small" icon-pack="feather" icon="icon-user" color="success" @click.prevent="nextFinalConsumer">CONSUMIDOR FINAL</vs-button>
                </vx-tooltip>
              </div>
            </vx-card>
          </div>
        </div>
      </tab-content>

      <!-- Products' selection -->
      <tab-content title="Toma de orden" icon="feather icon-shopping-cart" class="mb-5">
        <special-options-view :isSpecialActive="showComboOptions" :id="comboOptions"
                              @closeSidebar="showComboOptions = false" @addCouponCart="addCouponCart"/>
        <div>
          <div id="deltapos-instant-search-demo" class="mr-1">
            <div class="deltapos-header mb-2">
              <div class="flex md:items-end items-center justify-between flex-wrap">
                <!-- TOGGLE SIDEBAR BUTTON -->
                <feather-icon
                  class="inline-flex lg:hidden cursor-pointer mr-4"
                  icon="MenuIcon"
                  @click.stop="toggleFilterSidebar"/>

                <div class="flex justify-between items-center flex-grow">
                  <div class="flex items-center">
                    <div class="flex items-center" style="min-width: 260px !important;">
                      <vx-tooltip position="right" text="Cancelar orden y empezar de nuevo">
                        <vs-button color="danger" icon-pack="feather" icon="icon-x-circle" class="ml-2" @click="confirmCancel">CANCELAR</vs-button>
                      </vx-tooltip>
                      <vs-spacer/>
                      <vx-tooltip position="top" text="Cerrar toma de órdenes y regresar a inicio">
                        <vs-button color="success" icon-pack="feather" icon="icon-home" class="mr-1" :to="{name: 'home'}"></vs-button>
                      </vx-tooltip>
                    </div>
                    <vs-spacer/>
                    <span class="ml-8">
                      <vs-button v-if="index < maxCategories" v-for="(item, index) in categories" :key="item.id" @click="setCategory(item)" :type="(item.id == selectedCategory) ? 'border' : 'filled'" :style="(index == 0) ? 'border-radius: 5px 0px 0px 5px;' : 'border-radius: 0px;'">{{ item.name }}</vs-button>
                      <!--                        <span style="display: flex; align-items: center;" v-if="categories.length > maxCategories">-->
                            <vs-dropdown style="">
                          <vs-button type="filled" style="border-radius: 0px 5px 5px 0px;">Más...</vs-button>
                                <vs-dropdown-menu>
                                  <vs-dropdown-item v-if="index >= maxCategories" v-for="(item, index) in categories" :key="item.id" @click="setCategory(item)">{{ item.name }}</vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                      <!--                        </span>-->
                    </span>
                    <span>
                      <feather-icon
                        icon="GiftIcon"
                        @click="refineSpecial()"
                        class="p-2 ml-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                        :svgClasses="{'text-primary fill-current': specialSelected}"/>&nbsp;&nbsp;&nbsp;
                    </span>
                  </div>

                  <div class="flex items-start">
                    <!-- ITEM VIEW - GRID/LIST -->
                    <feather-icon
                      icon="GridIcon"
                      @click="currentItemView='item-grid-view'"
                      class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                      :svgClasses="{'text-primary stroke-current': currentItemView == 'item-grid-view'}"/>
                    <feather-icon
                      icon="ListIcon"
                      @click="currentItemView='item-list-view'"
                      class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                      :svgClasses="{'text-primary stroke-current': currentItemView == 'item-list-view'}"/>
                  </div>
                </div>
              </div>
            </div>

            <div id="deltapos-content-container" class="relative clearfix" style="min-height: 3000px !important;">
              <vs-sidebar
                class="items-no-padding vs-sidebar-rounded background-absolute"
                parent="#deltapos-content-container"
                :click-not-close="clickNotClose"
                :hidden-background="clickNotClose"
                v-model="isFilterSidebarActive">

                <div class="p-3 filter-container">
                  <feather-icon icon="ShoppingCartIcon" class="cursor-pointer ml-4 mr-6 mt-1"
                                :badge="cartItems.length"></feather-icon>
                  <template v-if="cartItems.length">
                    <div class="absolute top-0 right-0 py-4 px-6">
                      <b>{{ currencySymbol }}{{ parseFloat(orderTotal()).toFixed(2) }}</b>
                    </div>
                  </template>

                  <!-- IF CART HAVE ITEMS: HEADER -->
                  <template v-if="cartItems.length">
                    <div class="notification-header text-center p-5 bg-primary text-white">
                      <h3 class="text-white">{{ cartItems.length }} Item<span v-show="cartItems.length > 1">s</span>
                      </h3>
                      <vs-button color="success" size="mini" @click="confirmOrder">FINALIZAR
                      </vs-button>
                    </div>

                    <ul class="bordered-items">
                      <li v-for="(item, index) in cartItems" :key="item.id"
                          class="vx-row no-gutter cart-item cursor-pointer">
                        <div class="vx-col w-full pr-4 pl-2 py-4 flex flex-col justify-center">
                          <span class="font-medium block cart-item-title truncate">{{ item.name }}</span>
                          <small class="truncate mb-2">{{ item.code }}</small>
                          <!--                          <ul>-->
                          <!--                            <li v-for="option in item.selectedOptions" :key="option.id">-->
                          <!--                              <small class="truncate mb-2"><b>{{ option.name }}</b></small>-->
                          <!--                              <ul>-->
                          <!--                                <li v-for="productOption in option.products" :key="productOption.id">-->
                          <!--                                  <small class="truncate mb-2">{{ productOption.qtySelected }} {{ productOption.name }}</small>-->
                          <!--                                </li>-->
                          <!--                              </ul>-->
                          <!--                              <br>-->
                          <!--                            </li>-->
                          <!--                          </ul>-->
                          <div class="flex items-center justify-between">
                            <vs-input
                              size="small"
                              type="number"
                              :value="item.quantity"
                              style="width: 50px !important;"
                              @input="updateItemQuantity($event, item, index)"
                            />
                            <span class="text-sm font-small" v-if="item.discount == 0"><small>x {{ currencySymbol }}{{ parseFloat(item.price).toFixed(2) }} =</small> </span>
                            <span class="text-sm font-small" v-else><small>x {{ currencySymbol }}{{ parseFloat(item.price).toFixed(2) }} - {{ currencySymbol }}{{ parseFloat(item.discount).toFixed(2) }} =</small> </span>
                            <span class="text-sm font-small font-bold"> {{ currencySymbol }}{{ parseFloat(item.amount).toFixed(2) }}</span>
                            <feather-icon icon="XIcon" svgClasses="h-4 w-4 cursor-pointer text-danger"
                                          class="hover:text-danger" @click.stop="removeItemFromCart(item)"/>
                          </div>
                          <!--                          Instrucciones por producto-->
                          <!--                          <div class="flex items-center justify-between">-->
                          <!--                            <vs-input-->
                          <!--                              size="small"-->
                          <!--                              label-placeholder="Instrucciones"-->
                          <!--                              :value="item.cooking_instructions"-->
                          <!--                              @input="updateCookingInstructions($event, item, index)"-->
                          <!--                            />-->
                          <!--                          </div>-->
                        </div>
                      </li>
                      <li class="notification-header text-center p-5 bg-primary text-white">
                        <b class="text-white">TOTAL: {{ currencySymbol }}{{ parseFloat(orderTotal()).toFixed(2) }}</b>
                      </li>
                    </ul>
                  </template>

                  <!-- IF CART IS EMPTY -->
                  <template v-else>
                    <p class="p-4">No hay productos en pedido.</p>
                  </template>
                </div>
              </vs-sidebar>

              <!-- RIGHT COL -->
              <div :class="{'sidebar-spacer-with-margin': clickNotClose}">
                <!--              <div class="w-full">-->

                <div>
                  <!-- SEARCH BAR -->
                  <div>
                    <div class="relative">

                      <!-- SEARCH INPUT -->
                      <vs-input class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
                                placeholder="Buscar aquí" :value="refinementSearchValue" @input="refineSearch($event)"
                                @keyup.esc="clearRefinement" size="large"/>

                      <!-- SEARCH ICON -->
                      <div slot="submit-icon" class="absolute top-0 right-0 py-4 px-6" v-show="!currentRefinement">
                        <feather-icon icon="SearchIcon" svgClasses="h-6 w-6"/>
                      </div>

                      <!-- CLEAR INPUT ICON -->
                      <div slot="reset-icon" class="absolute top-0 right-0 py-4 px-6" v-show="currentRefinement">
                        <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer" @click="currentRefinement = ''"/>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SEARCH RESULT -->
                <div>

                  <!-- GRID VIEW -->
                  <template v-if="currentItemView == 'item-grid-view'">
                    <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings">
                      <div class="items-grid-view vx-row match-height">
                        <div class="vx-col w-1/4" v-for="(item, index) in products" :key="item.id">
                          <item-grid-view v-if="index < 20" :item="item" @addToCart="cartButtonClicked(item)">
                            <!-- SLOT: ACTION BUTTONS -->
                            <template slot="action-buttons">
                              <div class="flex flex-wrap">

                                <!-- PRIMARY BUTTON: ADD TO WISH LIST -->
                                <div
                                  class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer">

                                  <span class="text-2xl font-bold ml-2">{{ currencySymbol }}{{ parseFloat(item.price).toFixed(2) }}</span>
                                </div>

                                <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                                <div v-if="isInCart(item.id)"
                                     class="item-view-secondary-action-btn bg-success p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                                     @click="cartButtonClicked(item)">
                                  <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4"/>

                                  <span class="text-sm font-semibold ml-2">AGREGAR</span>
                                </div>
                                <div v-else
                                     class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                                     @click="cartButtonClicked(item)">
                                  <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4"/>

                                  <span class="text-sm font-semibold ml-2">AGREGAR</span>
                                </div>
                              </div>
                            </template>
                          </item-grid-view>

                        </div>
                      </div>
                    </VuePerfectScrollbar>
                  </template>

                  <!-- LIST VIEW -->
                  <template v-else>
                    <div class="items-list-view" v-for="(item, index) in products" :key="item.id">

                      <item-list-view v-if="index < 40" :item="item" :showAmount="false" :currencySymbol="currencySymbol">

                        <!-- SLOT: ACTION BUTTONS -->
                        <template slot="action-buttons">
                          <div
                            class="item-view-secondary-action-btn bg-primary p-3 rounded-lg flex flex-grow items-center justify-center text-white cursor-pointer"
                            @click="cartButtonClicked(item)">
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4"/>

                            <!--                      <span class="text-sm font-semibold ml-2" v-if="isInCart(item.objectID)">VER EN PEDIDO</span>-->
                            <!--                      <span class="text-sm font-semibold ml-2" v-else>AGREGAR A PEDIDO</span>-->
                            <span class="text-sm font-semibold ml-2">AGREGAR A PEDIDO</span>
                          </div>
                        </template>
                      </item-list-view>

                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab-content>

      <!-- tab 3 content -->
      <tab-content title="Confirmación de pedido" icon="feather icon-shopping-bag" class="mb-5">
        <promo-view :isPromoActive="showPromos" :id="promo" @closeSidebar="showPromos = false"
                    @applyPromo="applyPromo"/>

        <!-- IF CART HAVE ITEMS -->
        <div class="vx-row" v-if="cartItems.length">

          <!-- LEFT COL -->
          <div class="vx-col lg:w-2/3 w-full relative">
            <div class="items-list-view" v-for="(item, index) in cartItems" :key="item.id">
              <item-list-view :item="item" :showAmount="true" :currencySymbol="currencySymbol">

                <!-- SLOT: ITEM META -->
                <template slot="item-meta">
                  <h6 class="item-name font-semibold mb-1">{{ item.name }}</h6>
                  <p class="text-sm mb-4 cursor-pointer"><span class="text-primary font-semibold">{{ item.categoryName }}</span>
                  </p>
                  <p class="text-sm mb-4 cursor-pointer"><span class="text-primary">{{ item.comments }}</span></p>
                  <ul>
                    <li v-for="option in item.comboOptions" :key="option.id">
                      <small class="truncate mb-2"><b>{{ option.name }}</b></small>
                      <ul>
                        <li v-for="productOption in option.products" :key="productOption.id">
                          <small class="truncate mb-2">{{ productOption.qtySelected }} {{ productOption.name }}</small>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <p class="mt-4 font-bold text-sm">Cantidad</p>
                  <vs-input
                    type="number"
                    :value="item.quantity"
                    style="width: 50px !important;"
                    @input="updateItemQuantity($event, item, index)"
                  />
                  <div class="flex w-full">
                    <!--                  <vs-input-number min="1" max="10" :value="item.quantity" @input="updateItemQuantity($event, item, index)" class="inline-flex"/>-->
                    <div class="flex w-1/2 font-medium text-grey mt-4 items-top">
                      Precio unitario <br/>
                      {{ parseFloat(item.price).toFixed(2) }}
                    </div>
                    <div class="flex w-1/2 font-medium text-grey mt-4 items-center">
                      <span>% Descuento:</span>
                      <vs-input
                        type="number"
                        :value="item.discountPercent"
                        class="mx-2"
                        style="width: 80px !important;"
                        @input="updateItemDiscount($event, item, index)"
                      />
                      <span>= {{ parseFloat(item.discount).toFixed(2) }}</span>
                    </div>
                  </div>
                </template>

                <!-- SLOT: ACTION BUTTONS -->
                <template slot="action-buttons">

                  <!-- PRIMARY BUTTON: REMOVE -->
                  <div
                    class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3"
                    @click="removeItemFromCart(item)">
                    <feather-icon icon="XIcon" svgClasses="h-4 w-4"/>
                    <span class="text-sm font-semibold ml-2">ELIMINAR</span>
                  </div>
                </template>
              </item-list-view>
            </div>
          </div>

          <!-- RIGHT COL -->
          <div class="vx-col lg:w-1/3 w-full">
            <vx-card>
              <!--              <p class="text-grey mb-3">Opciones</p>-->
              <!--              <div class="flex justify-between">-->
              <!--                <span class="font-semibold">Cupones</span>-->
              <!--                <span class="font-medium text-primary cursor-pointer">Recibir</span>-->
              <!--              </div>-->
              <p class="text-grey mb-3">Enviar a</p>
              <div class="w-full font-bold" v-if="customerInfo.selectedName">{{ customerInfo.selectedName.name }}</div>
              <div class="w-full font-semibold">{{ customerInfo.phones }}</div>
              <vs-divider/>

              <p class="font-semibold mb-3">Detalle de precio</p>
              <div class="flex justify-between mb-2">
                <span class="text-grey font-bol">Total</span>
                <span class="font-bold">{{ parseFloat(subTotal()).toFixed(2) }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="allowGlobalDiscount">
                <span class="text-grey font-bol mt-1">% Descuento: </span>
                <vs-input
                  type="number"
                  size="small"
                  :value="globalDiscountPercent"
                  @input="globalDiscountChanged($event)"
                  style="max-width: 70px !important;"
                  class="ml-2"
                />
                <vs-spacer/>
                <span class="text-red-700 font-bold">-{{ parseFloat(globalDiscount).toFixed(2) }}</span>
              </div>
              <div class="flex h-5 content-center justify-between mb-2" v-if="!allowGlobalDiscount">
                <vs-avatar icon-pack="feather" icon="icon-plus" color="success" class="mr-2"
                           style="height: 16px; width: 16px;" @click="promoSelected = true"/>
                <span class="text-success mt-1">Descuentos:</span>
                <vs-spacer/>
                <!--                <span class="text-success">{{ parseFloat(discount).toFixed(2) }}</span>-->
              </div>
              <div class="flex h-5 content-center justify-between mb-2 ml-4" v-for="(item, index) in discounts" v-if="allowGlobalDiscount" :key="item.id">
                <vs-avatar icon-pack="feather" icon="icon-minus" color="danger" class="mr-2"
                           style="height: 16px; width: 16px;" @click="removePromo(index)"/>
                <span class="text-grey mt-1">{{ item.name }} {{ getAppliedDiscount(item) }}</span>
                <vs-spacer/>
                <span class="text-success">{{ parseFloat(item.value).toFixed(2) }}</span>
              </div>
              <div class="flex justify-between mb-2 mt-2">
                <span class="text-grey">Impuestos estimados</span>
                <span>{{ parseFloat(tax).toFixed(2) }}</span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Cargo por servicio</span>
                <span class="text-success">{{ parseFloat(serviceCharge).toFixed(2) }}</span>
              </div>

              <vs-divider/>

              <div class="flex justify-between text-4xl font-bold mb-3">
                <span>Total</span>
                <span>{{ currencySymbol }}{{ parseFloat(orderTotal()).toFixed(2) }}</span>
              </div>

              <vs-divider/>

              <vs-button class="w-full" @click="$refs.newOrderWizard.nextTab()">CONFIRMAR PEDIDO</vs-button>
              <vx-tooltip position="right" text="Cancelar orden y empezar de nuevo">
                <vs-button color="danger" icon-pack="feather" icon="icon-x-circle" class="w-full mt-2" @click="confirmCancel">CANCELAR</vs-button>
              </vx-tooltip>
            </vx-card>
          </div>
        </div>

        <!-- IF NO ITEMS IN CART -->
        <vx-card title="No tiene productos en el pedido" v-else>
          <vs-button @click="$router.push('/orders')">Tomar pedido</vs-button>
        </vx-card>

      </tab-content>

      <!-- tab 3 content -->
      <tab-content title="Datos de pago" icon="feather icon-credit-card" class="mb-5">

        <div class="vx-row">

          <!-- LEFT COL: PAYMENT OPTIONS -->
          <div class="vx-col lg:w-2/3 w-full">
            <vx-card title="Formas de pago" subtitle="Seleccionar por lo menos una forma de pago">

              <div class="mt-3">
                <ul>
                  <li v-for="(item, index) in paymentMethods" :key="item.id">
                    <!--                    <div class="flex flex-wrap justify-between items-center vx-row">-->
                    <div class="vx-row justify-between">
                      <div class="vx-col w-9/10" style="width: 80% !important;">
                        <h6 class="font-bold">{{ item.name }}</h6>
                        <div class="vx-row" v-if="item.type == 'TC'">
                          <div class="vx-col w-2/8" style="width: 170px !important;">
                            <vs-input
                              label-placeholder="Número de tarjeta de crédito"
                              name="cardNumber"
                              v-model="item.cardNumber"
                              size="small"
                              class="w-full"/>
                          </div>
                          <div class="vx-col w-5/8" style="flex: auto !important;">
                            <vs-input
                              label-placeholder="Nombre en tarjeta de crédito"
                              name="cardName"
                              v-model="item.cardName"
                              size="small"
                              class="w-full"/>
                          </div>
                          <div class="vx-col w-1/8" style="width: 130px !important;">
                            <vs-input
                              label-placeholder="Vence (MMAA)"
                              name="cardName"
                              v-model="item.cardExpiration"
                              size="small"
                              class="w-full"/>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-1/10">
                        <vs-input
                          size="large"
                          type="number"
                          :value="item.amount"
                          @input="amountPaidChanged($event, item, index)"
                          style="max-width: 100px !important;"
                          autofocus
                        />
                      </div>
                    </div>
                    <vs-divider class="my-6"/>
                  </li>
                </ul>
              </div>
            </vx-card>
          </div>

          <!-- RIGHT COL: PRICE -->
          <div class="vx-col lg:w-1/3 w-full">
            <vx-card title="Resumen de orden">
              <p class="text-grey mb-3">Enviar a</p>
              <div class="w-full font-bold" v-if="customerInfo.selectedName">{{ customerInfo.selectedName.name }}</div>
              <div class="w-full font-semibold">{{ customerInfo.phones }}</div>
              <vs-divider/>

              <div class="flex justify-between mb-2" v-if="globalDiscount > 0">
                <span class="text-grey font-bol mt-1">Sub total: </span>
                <span class="font-bold">{{ parseFloat(orderTotal() + globalDiscount).toFixed(2) }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="globalDiscount > 0">
                <span class="text-grey font-bol mt-1">{{ parseFloat(globalDiscountPercent).toFixed(2) }}% Descuento: </span>
                <span class="text-red-700 font-bold">-{{ parseFloat(globalDiscount).toFixed(2) }}</span>
              </div>
              <div class="flex justify-between mb-2">
                <span>Total a pagar</span>
                <span class="text-success"><div class="font-bold" v-if="orderTotal()">{{ currencySymbol }}{{ parseFloat(orderTotal()).toFixed(2) }}</div></span>
              </div>
              <div class="flex justify-between mb-2 mt-2">
                <span class="text-grey">Impuestos estimados</span>
                <span>{{ parseFloat(tax).toFixed(2) }}</span>
              </div>
              <div class="flex justify-between mb-2">
                <span>Total pagado</span>
                <span class="text-success">{{ currencySymbol }}{{ parseFloat(totalPaid).toFixed(2) }}</span>
              </div>
              <div class="flex justify-between mb-2">
                <span>Cambio</span>
                <span class="text-success">{{ currencySymbol }}{{ parseFloat(amountChange).toFixed(2) }}</span>
              </div>
              <vs-divider/>
              <vs-divider/>
              <vs-button ref="btnPlaceOrder" class="w-full" @click="submitOrder()" :disabled="placeOrderDisabled">COLOCAR ORDEN</vs-button>
              <vx-tooltip position="right" text="Cancelar orden y empezar de nuevo">
                <vs-button color="danger" icon-pack="feather" icon="icon-x-circle" class="w-full mt-2" @click="confirmCancel">CANCELAR</vs-button>
              </vx-tooltip>
            </vx-card>
          </div>
        </div>
      </tab-content>

    </form-wizard>
  </div>
</template>

<script>
import Vue from 'vue';
import {FormWizard, TabContent} from 'vue-form-wizard'
import vSelect from 'vue-select'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';


var deltaPOS_config = require('@/deltaPOS.config.js')

const ItemGridView = () => import('./components/ItemGridView.vue');
const ItemListView = () => import('./components/ItemListView.vue');
const ComboOptionsView = () => import('./components/CouponView.vue');
const SpecialOptionsView = () => import('./components/CouponView.vue');
const PromoView = () => import('./components/PromoView.vue');
import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';

Vue.use(TextBoxPlugin);

import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
import {GridPlugin, Search, Page, Sort, Toolbar} from '@syncfusion/ej2-vue-grids';
import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
import numbers from 'cldr-data/main/es-GT/numbers.json';
import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
import printJS from 'print-js'

Vue.use(GridPlugin);
Vue.use(DropDownListPlugin);

loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
setCulture('es-GT');
L10n.load({
  'es-GT': {
    'grid': {
      'EmptyRecord': 'No se encontraron clientes',
      'Search': 'Buscar',
      'Excelexport': 'Exportar'
    },
    'pager': {
      'currentPageInfo': '{0} de {1} páginas',
      'firstPageTooltip': 'Ir a primera página',
      'lastPageTooltip': 'Ir a última página',
      'nextPageTooltip': 'Ir a página siguiente',
      'previousPageTooltip': 'Ir a página anterior'
    }
  }
});

export default {
  data() {
    return {
      // TAB 2
      sessionId: 0,
      sessionData: null,
      currencyId: 0,
      currencySymbol: '',
      isFilterSidebarActive: false,
      clickNotClose: true,
      windowWidth: window.innerWidth,
      currentItemView: 'item-grid-view',
      products_collection: [],
      currentRefinement: '',
      refinementSearchValue: '',
      selectedCategory: false,
      selectedFlavors: [],
      addNewName: false,
      newName: '',
      finalConsumer: true,
      scheduledOrder: false,
      scheduledOrderDate: null,
      products_list: [],
      local_cartItems: [],
      specialSelected: false,
      showComboOptions: false,
      editingAddress: false,
      comboOptions: [],
      promo: {code: '', name: '', value: 0},
      promoSelected: false,
      showPromos: false,
      discounts: [],
      discountName: 'Descuento',
      deliveryInstructions: '',
      orderStartDate: '',
      allowGlobalDiscount: false,
      globalDiscountPercent: 0,
      maxDiscountPercent: 0,
      maxCategories: 5,
      taxPercent: 0,
      productStock: [],
      customerExtra1: '',
      customerExtra2: '',
      customerExtra3: '',
      customerExtra4: '',
      customerExtra5: '',
      ticketResolution: '',
      crfResolution: '',
      facResolution: '',
      defaultDocumentType: '',
      selectedDocumentType: '',
      dpiLabel: 'DPI',
      ticketDocumentType: '',
      posReference: '',
      customerTypes: [],
      documentTypes: [],
      categories: [],
      paymentMethods: [],
      placeOrderDisabled: false,
      customerSelected: false,
      editingCustomer: false,

      persons: [],
      pageSettings: {pageSize: 10},
      toolbarOptions: ['Search'],
      sortOptions: {columns: [{field: 'name'}, {field: 'vat'}]},

      customerInfo: {
        id: 0,
        phones: '',
        selectedName: null,
        selectedVAT: null,
        selectedEmail: '',
        store: '',
        deliveryInstructions: '',
        documentType: '',
        vat: '',
        name: '',
        address: '',
        state: '',
        city: '',
        email: '',
        DPI: '',
        customerType: '',
        extra1: '',
        extra2: '',
        extra3: '',
        extra4: '',
        extra5: '',
        type: '',
        isCustomer: true,
        names: [],
        addresses: [],
        taxIds: []
      },
      currentAddress: [],
      selectedAddress: {
        id: 0,
        address: '',
        state: null,
        city: null,
        referencePhones: '',
        store: null,
        storeRef: '',
        deliveryInstructions: ''
      },
      configScheduledOrder: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true
      },

      // TAB 1
      fullName: "",
      mobileNum: "",
      pincode: "",
      houseNum: "",
      area: "",
      landmark: "",
      city: "",
      state: "",
      discount: 0,
      serviceCharge: 0,
      addressType: 1,
      addressTypeOptions: [
        {text: 'Home', value: 1},
        {text: 'Office', value: 2},
      ],

      loading: false,

      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },

      // TAB 3
      paymentMethod: "debit-card",
      cvv: ''
    }
  },
  computed: {
    api() {
      return this.$store.getters.getParameter('connection').apiURL;
    },

    toValue() {
      return (value, range) =>
        [
          value.min !== null ? value.min : range.min,
          value.max !== null ? value.max : range.max,
        ];
    },

    // GRID VIEW
    isInCart() {
      return (itemId) => this.$store.getters['isInCart'](itemId)
    },
    order_categories: function () {
      return this.categories.slice(0, 9).map(function (el) {
        var o = Object.assign({}, el);
        o.selected = false;
        return o;
      });
    },
    products: function () {
      return this.refine()
    },
    cartItems() {
      return this.$store.state.cartItems;
    }
    ,
    old_subTotal() {
      // if (this.$store.state.cartItems.length > 0) {
      //   return this.$store.state.cartItems.map(item => item.amount).reduce((prev, next) => prev + next);
      // } else {
      //   return 0;
      // }
      if (this.cartItems.length > 0) {
        return this.cartItems.map(item => item.amount).reduce((prev, next) => prev + next);
      } else {
        return 0;
      }
    }
    ,
    old_orderTotal() {
      return this.subTotal() - this.discount;
    }
    ,
    tax() {
      return Math.round(this.taxPercent / 100 * this.orderTotal() / (1 + this.taxPercent / 100) * 100) / 100;
    },

    globalDiscount() {
      return Math.round(this.subTotal() * this.globalDiscountPercent) / 100;
    },

    totalPaid() {
      if (this.paymentMethods.length > 0) {
        return this.paymentMethods.map(item => item.amount).reduce((prev, next) => parseFloat(prev) + parseFloat(next));
      } else {
        return 0;
      }
    }
    ,
    amountChange() {
      return this.totalPaid - this.orderTotal();
    }
  },
  watch: {
    promoSelected: function () {
      this.showPromos = this.promoSelected;
      if (!this.promoSelected) {
        this.promo = {id: 0, code: '', name: '', value: 0};
      }
    }
  },
  provide: {
    grid: [Toolbar, Search, Page, Sort]
  },
  methods: {
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    }
    ,
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = false;
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true;
      }
    },

    // GRID VIEW - ACTIONS
    toggleFilterSidebar() {
      if (this.clickNotClose) return
      this.isFilterSidebarActive = !this.isFilterSidebarActive;
    },

    customerNameChanged(e) {
      this.$vs.loading({
        text: 'Buscando clientes',
        type: 'point'
      });
      var self = this;
      var data = {
        search: e.value,
        userId: this.$store.state.AppActiveUser.userId,
        token: this.$store.state.AppActiveUser.token
      };
      this.$http.post(deltaPOS_config.default.apiURL + '/customers/search', data).then(response => {
        if (response.data.success) {
          self.persons = response.data.data
        }
        this.$vs.loading.close();
        self.loaded = true;
      }).catch(error => {
        self.loaded = true;
        this.$vs.loading.close();
        var errorMessage = '';
        if (error.response) {
          errorMessage = error.response.data.ErrorMessage
        } else {
          errorMessage = 'Error de conectividad'
        }
        self.$vs.notify({
          title: 'Error al buscar personas',
          text: errorMessage,
          color: 'danger'
        });
      });
    },

    customerRowSelected(item) {
      this.clearCustomerInfo();
      this.customerInfo = {
        id: item.data.id,
        phones: item.data.phones,
        selectedName: item.data.name,
        selectedEmail: item.data.email,
        documentType: '',
        vat: item.data.vat,
        name: item.data.name,
        address: item.data.address,
        state: item.data.state,
        city: item.data.city,
        email: item.data.email,
        dpi: item.data.dpi,
        customerType: item.data.type,
        type: item.data.type,
        extra1: item.data.extra1,
        extra2: item.data.extra2,
        extra3: item.data.extra3,
        extra4: item.data.extra4,
        extra5: item.data.extra5,
        isCustomer: true,
        priceListId: item.data.priceListId,
        priceListName: item.data.priceListName,
        taxIds: []
      };
      this.customerSelected = true;
    },

    newCustomer() {
      this.clearCustomerInfo();
      this.$refs.gridCustomers.clearSelection();
      this.editingCustomer = true;
    },

    cancelCustomerEditing() {
      this.clearCustomerInfo();
      this.editingCustomer = false;
    },

    saveCustomer() {
      this.$vs.loading({
        text: 'Guardando información de cliente',
        type: 'point'
      });
      var self = this;
      this.customerInfo.context = this.$store.state.AppActiveUser;
      this.customerInfo.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
      this.$http.post(deltaPOS_config.default.apiURL + '/sale/customers/save', this.customerInfo).then(response => {
        if (response.data.success) {
          if (response.data.data) {
            self.customerInfo = response.data.data;
            self.$vs.notify({
              title: 'Información actualizada',
              text: 'Datos del cliente fueron actualizados correctamente',
              color: 'primary'
            });
          }
        } else {
          self.$vs.notify({
            title: 'Error al actualizar',
            text: response.data.message,
            color: 'danger'
          });
        }
        self.$vs.loading.close();
      }).catch(error => {
        self.loaded = true;
        this.$vs.loading.close();
        var errorMessage = '';
        if (error.response) {
          errorMessage = error.response.data.ErrorMessage
        } else {
          errorMessage = 'Error de conectividad'
        }
        self.$vs.notify({
          title: 'Error al guardar información de cliente',
          text: errorMessage,
          color: 'danger'
        });
      });
    },

    nextWithCustomer() {
      if (this.customerInfo.id > 0) {
        if (this.customerInfo.priceListId > 0) {
          this.$vs.loading({
            text: 'Cargando lista de precios del cliente',
            type: 'point'
          });
          var self = this;
          this.$http.post(deltaPOS_config.default.apiURL + '/sale/price_lists/data', {id: this.customerInfo.priceListId, context: self.$store.state.AppActiveUser})
            .then(response => {
              self.$vs.loading.close();
              if (response.data.success) {
                if (response.data.data) {
                  if (response.data.data.products) {
                    var product;
                    for (var i = 0; i < self.products_collection.length; i++) {
                      product = response.data.data.products.filter(item => item.id == self.products_collection[i].id);
                      if (product.length > 0) {
                        self.products_collection[i].price = product[0].price;
                      } else {
                        self.products_collection[i].price = this.products_collection[i].listPrice;
                      }
                    }
                  }
                }
              }
            });
        }
        this.finalConsumer = false;
        this.$refs.newOrderWizard.nextTab();
      } else {
        this.$vs.notify({
          title: 'Error al seleccionar cliente',
          text: "Debe seleccionar un cliente para poder continuar",
          color: 'danger'
        });
      }
    },

    nextFinalConsumer() {
      for (var i = 0; i < this.products_collection.length; i++) {
        this.products_collection[i].price = this.products_collection[i].listPrice;
      }
      this.clearCustomerInfo();
      this.finalConsumer = true;
      this.$refs.newOrderWizard.nextTab();
    }
    ,

    confirmCancel() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirme`,
        text: '¿Estás seguro de cancelar la orden en proceso? Se perderán los datos ingresados',
        acceptText: 'Si',
        cancelText: 'No',
        accept: this.acceptCancel
      })
    }
    ,
    acceptCancel() {
      this.resetAndClearCart();
    }
    ,
    confirmClose() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirme`,
        text: '¿Estás seguro de cerrar la toma de órdenes? Se perderán los datos ingresados',
        acceptText: 'Si',
        cancelText: 'No',
        accept: this.closeOrder
      })
    }
    ,
    closeOrder() {
      this.resetOrder();
      this.$router.push({name: 'home'});
    }
    ,

    itemOnHand(item) {
      return this.$store.getters.getStock({warehouseId: 1, productId: item.id}).onHand;
    },

    additemInCart(item) {
      this.$store.dispatch('additemInCart', item)
    }
    ,
    local_additemInCart(item) {
      item["quantity"] = 1;
      item["amount"] = item["quantity"] * item["price"];
      this.cartItems.push(item);
    }
    ,
    addCouponCart() {
      this.additemInCart(this.comboOptions);
    }
    ,
    getPromoValue(promo) {
      var ret = '';
      if (promo) {
        if (promo.type != '') {
          if (promo.type == 'PERCENT') {
            if (promo.percent) {
              ret += '(' + parseFloat(promo.percent).toFixed(2).toString() + '%)';
            }
          } else {
            if (promo.price) {
              ret += `(${this.currencySymbol}${parseFloat(promo.price).toFixed(2).toString()})`;
            }
          }
        }
      }
      return ret;
    }
    ,
    getAppliedDiscount(promo) {
      var ret = '';
      if (promo.type == 'PERCENT') {
        ret = `(-${promo.percent}%)`;
      } else {
        ret = `(-${this.currencySymbol}${promo.price})`;
      }
      return ret;
    }
    ,
    removePromo(index) {
      if (index < this.discounts.length) {
        this.discount -= this.discounts[index].value;
        this.discounts.splice(index, 1);
      }
    }
    ,
    applyPromo() {
      this.promoSelected = false;
      if (this.promo.code != '') {
        if (this.promo.productId == '') {
          if (this.promo.type == 'PERCENT') {
            var existingDiscount = this.discounts.find(discount => discount.type == this.promo.type);
            if (existingDiscount) {
              this.$vs.notify({
                title: 'Error al cargar promoción',
                text: 'No puede seleccionar dos promociones de descuento en una misma orden',
                color: 'danger'
              })
            } else {
              this.promo.value = Math.round(this.subTotal() * this.promo.percent) / 100;
              this.discounts.push(this.promo);
              this.discount += this.promo.value;
            }
          }
        } else {
          if (this.isInCart(this.promo.productId)) {
            var index = -1;
            for (var i = 0; i < this.$store.state.cartItems.length; i++) {
              if (this.$store.state.cartItems[i].id == this.promo.productId) {
                index = i;
              }
            }
            if (index >= 0) {
              var amount = this.$store.state.cartItems[index].quantity * this.$store.state.cartItems[index].price;
              if (this.promo.type == 'PERCENT') {
                this.promo.value = Math.round(amount * this.promo.percent) / 100;
              } else {
                if (this.promo.price <= this.$store.state.cartItems[index].price) {
                  this.promo.value = this.$store.state.cartItems[index].price - this.promo.price * this.$store.state.cartItems[index].quantity;
                }
              }
              // this.$store.dispatch("updateItemDiscount", {discount: this.discount, index: index});
              this.discounts.push(this.promo);
              this.discount += this.promo.value;
            } else {
              this.$vs.notify({
                title: 'Error al aplicar descuento',
                text: `El producto ${this.promo.name} no se encuentra en el pedido`,
                color: 'danger'
              });
            }
          } else {
            this.$vs.notify({
              title: 'Error al aplicar descuento',
              text: `El producto ${this.promo.name} no se encuentra en el pedido`,
              color: 'danger'
            });
          }
        }
      }
    }
    ,
    cartButtonClicked(item) {
      var newQty = 0;
      var self = this;
      if (item.combo) {
        this.comboOptions = JSON.parse(JSON.stringify(item));
        this.showComboOptions = true;
      } else {
        var index = -1;
        for (var i = 0; i < this.$store.state.cartItems.length; i++) {
          if (this.$store.state.cartItems[i].id == item.id && !this.$store.state.cartItems[i].combo) {
            index = i;
          }
        }
        if (index >= 0) {
          newQty = this.$store.state.cartItems[index].quantity + 1;
          self.updateItemQuantity(newQty, item, index);
        } else {
          self.additemInCart(item);
        }
      }
    }
    ,
    getCategory(id) {
      var ret = '-';
      for (var i = 0; i < this.categories.length; i++) {
        if (this.categories[i].id == id) {
          ret = this.categories[i].name;
        }
      }
      return ret;
    }
    ,
    setCategory(category) {
      this.currentRefinement = '';
      this.refinementSearchValue = '';
      if (this.selectedCategory == category.code) {
        this.selectedCategory = false;
      } else {
        this.selectedCategory = category.id;
      }
    }
    ,
    refineByCategory(code) {
      this.selectedCategory = code;
    }
    ,
    refineByFlavor(id) {
      var pos = this.flavors.indexOf(id);
      if (pos >= 0) {
        this.selectedFlavors.splice(pos, 1);
      } else {
        this.selectedFlavors.push(id);
      }
    }
    ,

    clearRefinement() {
      this.currentRefinement = '';
      this.refinementSearchValue = '';
    }
    ,

    refineSearch(event) {
      this.refinementSearchValue = event;
      // if (event.length > 3) {
      this.currentRefinement = event;
      // }
    }
    ,

    refineSpecial() {
      this.specialSelected = !this.specialSelected;
      // this.refine()
    }
    ,

    refine() {
      var result = this.products_collection;
      if (this.currentRefinement != "") {
        result = result.filter(item => (item.name.toLowerCase().indexOf(this.currentRefinement.toLowerCase()) !== -1 || item.code.toLowerCase().indexOf(this.currentRefinement.toLowerCase()) !== -1));
        this.selectedCategory = false;
        this.specialSelected = false;
      } else {
        if (this.selectedCategory) {
          result = result.filter(item => item.categoryId == this.selectedCategory);
        }
        if (this.specialSelected) {
          result = result.filter(item => item.combo == true);
        }
      }
      return result;
    }
    ,

    local_isInCart(itemId) {
      return this.cartItems.some((item) => item.id == itemId)
    }
    ,

    noSubmit(event) {
      event.preventDefault();
    }
    ,
    getItemQuantity(item) {
      return item.quantity;
    }
    ,
    subTotal() {
      // if (this.$store.state.cartItems.length > 0) {
      //   return this.$store.state.cartItems.map(item => item.amount).reduce((prev, next) => prev + next);
      // } else {
      //   return 0;
      // }
      if (this.cartItems.length > 0) {
        return this.cartItems.map(item => item.amount).reduce((prev, next) => prev + next);
      } else {
        return 0;
      }
    },

    orderTotal() {
      return this.subTotal() - this.discount - this.globalDiscount;
    },

    clearCustomerInfo() {
      this.customerInfo = {
        id: 0,
        phones: '',
        selectedName: null,
        selectedEmail: '',
        store: '',
        deliveryInstructions: '',
        names: [],
        addresses: [],
        documentType: null,
        vat: '',
        name: '',
        address: '',
        state: '',
        city: '',
        email: '',
        dpi: '',
        customerType: '',
        extra1: '',
        extra2: '',
        extra3: '',
        extra4: '',
        extra5: '',
        isCustomer: true,
        taxIds: []
      };
      this.scheduledOrder = false;
    }
    ,

    validateVAT() {
      this.customerInfo.vat = this.customerInfo.vat.trim();
      if (this.customerInfo.vat == '') {
        this.clearCustomerInfo()
      } else {
        var self = this;
        var data = {
          vat: this.customerInfo.vat,
          userId: this.$store.state.AppActiveUser.userId,
          token: this.$store.state.AppActiveUser.token
        };
        this.$http.post(deltaPOS_config.default.apiURL + '/customers/check_vat', data).then(response => {
          if (response.data.success) {
            if (response.data.data) {
              self.customerInfo.id = response.data.data.id;
              self.customerInfo.nameVAT = response.data.data.name;
              self.customerInfo.addressVAT = response.data.data.address;
              self.customerInfo.state = response.data.data.state;
              self.customerInfo.city = response.data.data.city;
              self.customerInfo.phones = response.data.data.phones;
              self.customerInfo.email = response.data.data.email;
              self.customerInfo.DPI = response.data.data.dpi;
              self.customerInfo.extra1 = response.data.data.extra1;
              self.customerInfo.extra2 = response.data.data.extra2;
              self.customerInfo.extra3 = response.data.data.extra3;
              self.customerInfo.extra4 = response.data.data.extra4;
              self.customerInfo.extra5 = response.data.data.extra5;
              self.customerInfo.customerType = this.customerTypes.filter(item => (item.code == response.data.data.type));
            }
          }
        });
      }
    }
    ,

    clearPayment() {
      for (var i = 0; i < this.paymentMethods.length; i++) {
        // this.$store.dispatch("updatePaymentAmount", {amount: 0, index: i});
        this.paymentMethods[i].amount = 0;
      }
    }
    ,

    clearCart() {
      // while (this.$store.state.cartItems.length > 0) {
      //   this.removeItemFromCart(this.$store.state.cartItems[0]);
      // }
      while (this.cartItems.length > 0) {
        this.$store.dispatch('toggleItemInCart', this.cartItems[0]);
        // this.cartItems.pop();
      }
      this.promoSelected = false;
    }
    ,

    setSelectedVAT(value) {
      this.customerInfo.vat = value;
      this.customerInfo.selectedVAT = value;
    }
    ,

    // TAB 1
    removeItemFromCart(item) {
      this.$store.dispatch('toggleItemInCart', item)
    },

    updateItemQuantity(event, item, index) {
      var quantity = parseInt(event);
      // const itemIndex = Math.abs(index + 1 - this.cartItems.length)
      // this.$store.dispatch("updateItemQuantity", {quantity: item.quantity, index: itemIndex})
      this.$store.dispatch("updateItemQuantity", {quantity: quantity, index: index});

      // if (quantity <= 1) {
      //   quantity = 1;
      // }
      //
      // this.cartItems[index].quantity = quantity;
      // this.cartItems[index].amount = quantity * item.price;

      this.$forceUpdate();
    },

    updateItemDiscount(event, item, index) {
      if (event == '') event = 0;
      let percent = Math.abs(parseFloat(event));
      if (percent > 50) {
        percent = 50;
      }
      this.$store.dispatch("updateItemDiscountPercent", {percent: percent, index: index});

      // if (quantity <= 1) {
      //   quantity = 1;
      // }
      //
      // this.cartItems[index].quantity = quantity;
      // this.cartItems[index].amount = quantity * item.price;

      this.$forceUpdate();
    },

    updateCookingInstructions(event, item, index) {
      this.$store.dispatch("updateCookingInstructions", {cooking_instructions: event, index: index});
      this.$forceUpdate();
    }
    ,

    globalDiscountChanged(event) {
      var percent = parseFloat(event);
      if (percent > this.maxDiscountPercent) {
        this.globalDiscountPercent = this.maxDiscountPercent
      } else {
        this.globalDiscountPercent = percent;
      }
    }
    ,

    amountPaidChanged(event, item, index) {
      // this.$store.dispatch("updatePaymentAmount", {amount: parseFloat(event), index: index});
      this.paymentMethods[index].amount = parseFloat(event);
    }
    ,

    trimAddress(event) {
      this.selectedAddress.address = event.target.value.substring(0, 60).trim();
    }
    ,

    blurNewName(event) {
      this.newName = event.target.value.trim();
    }
    ,

    blurReferencePhones(event) {
      this.selectedAddress.referencePhones = event.target.value.trim();
    }
    ,

    blurEmail(event) {
      this.customerInfo.selectedEmail = event.target.value.trim();
    }
    ,

    inputDeliveryInstructions(value) {
      this.deliveryInstructions = value.trim();
    }
    ,

    blurDeliveryInstructions() {
      this.selectedAddress.deliveryInstructions = this.deliveryInstructions.trim();
    }
    ,

    confirmOrder() {
      this.$refs.newOrderWizard.nextTab();
    }
    ,

    printOrderBAK(order) {
      var pdf = window.atob(order.printDocument);
      var filename = order.number;

      var byteArrays = [];
      var sliceSize = 512;
      for (var offset = 0; offset < pdf.length; offset += sliceSize) {
        var slice = pdf.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      var blob = new Blob(byteArrays, {type: "application/pdf",});
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        var elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    }
    ,

    printOrder(order) {
      printJS({printable: order.printDocument, type: 'pdf', base64: true});
    }
    ,

    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    }
    ,

    submitOrder() {
      var self = this;
      if (this.orderTotal() > this.totalPaid) {
        this.$vs.notify({
          title: 'Error',
          text: 'Monto pendiente de pago',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      } else if (!this.selectedDocumentType) {
        this.$vs.notify({
          title: 'Error',
          text: 'Debe seleccionar un tipo de documento',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      } else {
        this.placeOrderDisabled = true;
        this.loading = true;
        this.$vs.loading({type: 'point', text: 'Guardando orden, espere confirmación'});
        setTimeout(() => {
          if (this.loading) {
            this.$vs.loading.close();
            self.$vs.notify({
              title: 'Error al insertar orden',
              text: 'No se recibió respuesta de backend luego de 60 segundos de espera, por favor notificar al área de soporte',
              color: 'warning'
            });
          }
        }, 60000);

        var orderCoupons = [];
        for (itemsCount = 0; itemsCount < this.discounts.length; itemsCount++) {
          orderCoupons.push({
            code: this.discounts[itemsCount].code,
            name: this.discounts[itemsCount].name,
            quantity: 1,
            price: this.discounts[itemsCount].value,
            amount: this.discounts[itemsCount].percent,
          });
        }

        // var resolution = this.ticketResolution;
        // var documentType = this.customerInfo.documentType ? this.customerInfo.documentType.code : this.ticketDocumentType;
        // if (documentType == 'CRF') {
        //   resolution = this.crfResolution;
        // } else if (documentType == 'FAC') {
        //   resolution = this.facResolution;
        // }
        var documentType = this.documentTypes.find(item => item.code == this.selectedDocumentType);

        var data = {
          documentType: documentType.code,
          customerId: this.customerInfo.id,
          vat: (this.finalConsumer ? '' : this.customerInfo.vat),
          invoiceName: (this.finalConsumer ? '' : this.customerInfo.name),
          invoiceAddress: (this.finalConsumer ? '' : this.customerInfo.address),
          state: (this.finalConsumer ? '' : this.customerInfo.state),
          city: (this.finalConsumer ? '' : this.customerInfo.city),
          phone: (this.finalConsumer ? '' : this.customerInfo.phones),
          email: (this.finalConsumer ? '' : this.customerInfo.email),
          dpi: (this.finalConsumer ? '' : this.customerInfo.dpi),
          customerType: (this.finalConsumer ? '' : this.customerInfo.type),
          extra1: (this.finalConsumer ? '' : this.customerInfo.extra1),
          extra2: (this.finalConsumer ? '' : this.customerInfo.extra2),
          extra3: (this.finalConsumer ? '' : this.customerInfo.extra3),
          extra4: (this.finalConsumer ? '' : this.customerInfo.extra4),
          extra5: (this.finalConsumer ? '' : this.customerInfo.extra5),
          discountPercent: this.globalDiscountPercent,
          discount: this.discount + this.globalDiscount,
          orderTotal: this.orderTotal(),
          salesmanId: parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`)),
          createdBy: parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`)),
          sessionId: this.sessionData.id,
          posReference: this.posReference,
          origin: 'deltaPOS',
          function: 'VEN',
          statusId: 'OPE',
          currencyId: this.currencyId,
          resolution: documentType.resolutionId,
          products: [],
          payments: [],
          coupons: orderCoupons,
          context: this.$store.state.AppActiveUser
        };
        var product = null;
        for (var itemsCount = 0; itemsCount < this.$store.state.cartItems.length; itemsCount++) {
          product = {
            productId: parseInt(this.$store.state.cartItems[itemsCount].id),
            code: this.$store.state.cartItems[itemsCount].code,
            description: this.$store.state.cartItems[itemsCount].name,
            price: parseFloat(this.$store.state.cartItems[itemsCount].price),
            quantity: parseInt(this.$store.state.cartItems[itemsCount].quantity),
            discountPercent: parseFloat(this.$store.state.cartItems[itemsCount].discountPercent),
            discountValue: parseFloat(this.$store.state.cartItems[itemsCount].discount),
            amount: parseFloat(this.$store.state.cartItems[itemsCount].amount),
            function: '-'
          };
          if (this.$store.state.cartItems[itemsCount].hasOwnProperty('comboOptions')) {
            var couponProducts = [];
            if (this.$store.state.cartItems[itemsCount].comboOptions) {
              for (var comboOptionsCount = 0; comboOptionsCount < this.$store.state.cartItems[itemsCount].comboOptions.length; comboOptionsCount++) {
                for (var productsOptionCount = 0; productsOptionCount < this.$store.state.cartItems[itemsCount].comboOptions[comboOptionsCount].products.length; productsOptionCount++) {
                  couponProducts.push({
                    id: productsOptionCount,
                    code: this.$store.state.cartItems[itemsCount].comboOptions[comboOptionsCount].products[productsOptionCount].code,
                    name: this.$store.state.cartItems[itemsCount].comboOptions[comboOptionsCount].products[productsOptionCount].name,
                    answerId: this.$store.state.cartItems[itemsCount].comboOptions[comboOptionsCount].products[productsOptionCount].forcedChoiceId,
                    price: 0,
                    quantity: this.$store.state.cartItems[itemsCount].comboOptions[comboOptionsCount].products[productsOptionCount].qtySelected,
                    amount: 0,
                    couponProducts: []
                  })
                }
              }
            }
            product['couponProducts'] = couponProducts;
          }
          data.products.push(product);
        }
        for (itemsCount = 0; itemsCount < this.paymentMethods.length; itemsCount++) {
          if (this.paymentMethods[itemsCount].amount > 0) {
            data.payments.push({
              paymentId: this.paymentMethods[itemsCount].id,
              amount: parseFloat(this.paymentMethods[itemsCount].amount),
            });
          }
        }

        this.$http.post(`${this.api}/orders/save`, data).then(response => {
          self.$vs.loading.close();
          self.loading = false;
          if (response.data.success) {
            if (response.data.data) {
              if (response.data.data.id > 0) {
                if (response.data.data.printDocument) {
                  if (response.data.data.printDocument != '') {
                    self.printOrder(response.data.data);
                  }
                }
                self.$vs.dialog({
                  type: 'confirm',
                  color: 'success',
                  title: 'Orden insertada',
                  text: "Orden deltaPOS: " + response.data.data.id.toString(),
                  buttonCancel: 'flat',
                  acceptText: 'Aceptar',
                  cancelText: '',
                  accept: self.resetAndClearCart,
                  cancel: self.resetAndClearCart
                });
              }
            } else {
              self.placeOrderDisabled = false;
              self.$vs.notify({
                title: 'Error al insertar orden: No se recibió respuesta de backend',
                text: response.data.data.Message,
                color: 'danger'
              });
            }
          } else {
            self.placeOrderDisabled = false;
            self.$vs.notify({
              title: 'Error al insertar orden: Fallo al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
        }).catch(error => {
          self.placeOrderDisabled = false;
          self.$vs.loading.close();
          self.loading = false;
          var errorMessage = '';
          if (error.message) {
            errorMessage = error.message;
          } else {
            errorMessage = 'Error de conectividad'
          }
          self.$vs.notify({
            title: 'Error al insertar orden',
            text: errorMessage,
            color: 'danger'
          });
        })
      }
    }
    ,

    getStock() {
      var self = this;
      var data = {
        warehouseId: this.sessionData.warehouseId,
        userId: this.$store.state.AppActiveUser.userId,
        token: this.$store.state.AppActiveUser.token
      };
      this.$http.post(deltaPOS_config.default.apiURL + '/stock/on_hand/warehouse', data)
        .then(response => {
          if (response.data.success) {
            if (response.data.data) {
              var product;
              for (var i = 0; i < response.data.data.length; i++) {
                product = self.products_collection.find(item => item.id === response.data.data[i].id);
                if (product) {
                  product['onHand'] = response.data.data[i].onHand;
                }
              }
            }
          }
        });
    }
    ,

    getDocumentTypes() {
      var self = this;
      this.$http.post(deltaPOS_config.default.apiURL + '/sale/document_types/list', this.$store.state.AppActiveUser).then(response => {
        if (response.data.success) {
          if (response.data.data) {
            self.documentTypes = response.data.data;
          }
        }
      });
    }
    ,

    getCustomerTypes() {
      var self = this;
      this.$http.post(deltaPOS_config.default.apiURL + '/customers/types', this.$store.state.AppActiveUser).then(response => {
        if (response.data.success) {
          if (response.data.data) {
            self.customerTypes = response.data.data;
          }
        }
      });
    }
    ,

    getProducts() {
      var self = this;
      this.$http.post(deltaPOS_config.default.apiURL + '/products/order_list', this.$store.state.AppActiveUser).then(response => {
        if (response.data.success) {
          if (response.data.data) {
            self.products_collection = response.data.data;
          }
        }
      });
    }
    ,

    resetAndClearCart() {
      this.resetOrder();
      this.clearCart();
    }
    ,

    resetOrder() {
      this.$refs.newOrderWizard.reset();
      this.customerSelected = false;
      this.editingCustomer = false;
      this.clearCustomerInfo();
      // this.clearCart();
      this.clearPayment();
      this.discounts = [];
      this.discount = 0;
      this.globalDiscountPercent = 0;
      this.posReference = this.uuidv4();
      this.placeOrderDisabled = false;
      this.selectedDocumentType = this.defaultDocumentType;
      if (this.categories.length > 0) {
        this.setCategory(this.categories[0]);
      }
      this.finalConsumer = true;
    }
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize);
    });
    this.setSidebarWidth();
  },
  dateISOFormat(value) {
    const d = new Date(value.getTime() - (6 * 60 * 60 * 1000));
    return d.toISOString();
  },
  mounted() {
    this.$vs.loading({
      text: 'Configurando punto de venta',
      type: 'point'
    });
    this.sessionId = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}CashSessionId`));
    if (this.sessionId > 0) {
      var self = this;
      this.$http
        .post(deltaPOS_config.default.apiURL + '/sale/cash_register/get_session_data', {id: this.sessionId, context: this.$store.state.AppActiveUser})
        .then(response => {
          var openSession = false;
          if (response.data.success) {
            if (response.data) {
              self.sessionData = response.data.data;
              self.documentTypes = response.data.data.resolutions;
              openSession = true;
            }
          }
          if (openSession) {
            self.$http
              .post(deltaPOS_config.default.apiURL + '/parameters/list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token})
              .then(response => {
                if (response.data.success) {
                  for (var i = 0; i < response.data.data.length; i++) {
                    if (response.data.data[i].parameter == 'ORDENES') {
                      if (response.data.data[i].code == 'DATOADICIONALCLIENTE1') {
                        self.customerExtra1 = response.data.data[i].value;
                      } else if (response.data.data[i].code == 'DATOADICIONALCLIENTE2') {
                        self.customerExtra2 = response.data.data[i].value;
                      } else if (response.data.data[i].code == 'DATOADICIONALCLIENTE3') {
                        self.customerExtra3 = response.data.data[i].value;
                      } else if (response.data.data[i].code == 'DATOADICIONALCLIENTE4') {
                        self.customerExtra4 = response.data.data[i].value;
                      } else if (response.data.data[i].code == 'DATOADICIONALCLIENTE5') {
                        self.customerExtra5 = response.data.data[i].value;
                      } else if (response.data.data[i].code == 'PERMITIRDESCUENTOGLOBAL') {
                        self.allowGlobalDiscount = (response.data.data[i].value.toLowerCase() == 'si');
                      } else if (response.data.data[i].code == 'MAXIMODESCUENTOGLOBAL') {
                        self.maxDiscountPercent = parseFloat(response.data.data[i].value);
                      } else if (response.data.data[i].code == 'PORCENTAJEIVA') {
                        self.taxPercent = parseFloat(response.data.data[i].value);
                      } else if (response.data.data[i].code == 'TIPODOCUMENTODEFAULT') {
                        self.defaultDocumentType = response.data.data[i].value;
                        self.selectedDocumentType = self.defaultDocumentType;
                      } else if (response.data.data[i].code == 'ETIQUETADPI') {
                        self.dpiLabel = response.data.data[i].value;
                      } else if (response.data.data[i].code == 'MAXIMOCATEGORIAS') {
                        self.dpiLabel = parseInt(response.data.data[i].value);
                      }
                    } else if (response.data.data[i].parameter == 'MONEDALOCAL') {
                      if (response.data.data[i].code == 'ID') {
                        self.customerExtra1 = response.data.data[i].value;
                        self.currencyId = parseInt(response.data.data[i].value);
                      } else if (response.data.data[i].code == 'SIMBOLO') {
                        self.currencySymbol = response.data.data[i].value;
                      }
                    }
                  }
                  self.$http
                    .post(deltaPOS_config.default.apiURL + '/customers/types', self.$store.state.AppActiveUser)
                    .then(response => {
                      if (response.data.success) {
                        self.customerTypes = response.data.data;
                      }
                      self.$http
                        .post(deltaPOS_config.default.apiURL + '/products/categories/list', self.$store.state.AppActiveUser)
                        .then(response => {
                          if (response.data.success) {
                            self.categories = response.data.data;
                            if (self.categories.length > 0) {
                              self.setCategory(self.categories[0]);
                            }
                          }
                          self.$http
                            .post(deltaPOS_config.default.apiURL + '/orders/payment_methods/list', self.$store.state.AppActiveUser)
                            .then(response => {
                              if (response.data.success) {
                                self.paymentMethods = response.data.data;
                              }
                              self.$http
                                .post(deltaPOS_config.default.apiURL + '/products/order_list', self.$store.state.AppActiveUser)
                                .then(response => {
                                  if (response.data.success) {
                                    self.products_collection = response.data.data;
                                  }
                                  self.$http
                                    .post(deltaPOS_config.default.apiURL + '/stock/on_hand/warehouse', {warehouseId: self.sessionData.warehouseId, userId: self.$store.state.AppActiveUser.userId, token: self.$store.state.AppActiveUser.token})
                                    .then(response => {
                                      if (response.data.success) {
                                        if (response.data.data) {
                                          // var product;
                                          var index;
                                          for (var i = 0; i < response.data.data.length; i++) {
                                            index = self.products_collection.findIndex(item => item.id === response.data.data[i].productId);
                                            if (index >= 0) {
                                              self.products_collection[index]['onHand'] = response.data.data[i].onHand;
                                            }
                                            /*
                                                                                          product = self.products_collection.find(item => item.id === response.data.data[i].productId);
                                                                                          if (product) {
                                                                                            index = self.products_collection.indexOf(product);
                                                                                            if (index >= 0) {
                                                                                              self.products_collection[index]['onHand'] = response.data.data[i].onHand;
                                                                                            }
                                                                                          }
                                            */
                                          }
                                        }
                                      }
                                      self.orderStartDate = dateISOFormat(new Date());
                                      self.posReference = this.uuidv4();
                                      self.$vs.loading.close();
                                    });
                                });
                            });
                        });
                    });
                }
              });
          } else {
            self.$vs.notify({
              title: 'Error al cargar parámetros de venta',
              text: 'No se encontró sesión de caja',
              color: 'danger'
            });
          }
        })
        .catch(error => {
          self.loaded = true;
          self.$vs.loading.close();
          var errorMessage = '';
          if (error.response) {
            errorMessage = error.response.data.ErrorMessage
          } else if (error.message) {
            errorMessage = error.message;
            if (error.config) {
              if (error.config.url) {
                errorMessage = `${errorMessage}: ${error.config.url}`;
              }
            }
          }
          self.$vs.notify({
            title: 'Error al cargar parámetros de venta',
            text: errorMessage,
            color: 'danger'
          });
        });
    } else {
      this.$vs.loading.close();
      this.$vs.notify({
        title: 'Error al iniciar sesión de venta',
        text: 'No se ha definido una sesión de caja',
        color: 'danger'
      });
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleWindowResize)
  }
  ,
  components: {
    ItemGridView,
    ItemListView,
    ComboOptionsView,
    SpecialOptionsView,
    PromoView,
    FormWizard,
    TabContent,
    flatPickr,
    'v-select':
    vSelect,
    VuePerfectScrollbar,
  }
}

function dateISOFormat(value) {
  const d = new Date(value.getTime() - (6 * 60 * 60 * 1000));
  return d.toISOString();
}
</script>

<style lang="scss" scoped>
@import '../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

#deltapos-instant-search-demo {
  .deltapos-header {
    .deltapos-filters-label {
      width: calc(260px + 2.4rem);
    }
  }

  #deltapos-content-container {

    .vs-sidebar {
      position: relative;
      float: left;
    }
  }

  .deltapos-search-input-right-aligned-icon {
    padding: 1rem 1.5rem;
  }

  .deltapos-price-slider {
    min-width: unset;
  }

  .item-list-view {
    .deltapos-result-img {

    }
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}

.theme-dark {
  #deltapos-instant-search-demo {
    #deltapos-content-container {
      .vs-sidebar {
        background-color: #10163a;
      }
    }
  }
}

@media (min-width: 992px) {
  .vs-sidebar-rounded {
    .vs-sidebar {
      border-radius: .5rem;
    }

    .vs-sidebar--items {
      border-radius: .5rem;
    }
  }
}

@media (max-width: 3000px) {
  #deltapos-content-container {
    .vs-sidebar {
      position: absolute !important;
      float: none !important;
    }
  }
}

#deltapos-new-order {
  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
  }

  .item-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
  }

  .vue-form-wizard {
    /deep/ .wizard-header {
      padding: 0;
      height: 5px !important;
    }

    /deep/ .wizard-tab-content {
      padding-right: 0;
      padding-left: 0;
    }
  }
}

.deltapos-cart-dropdown {
  width: 100px;

  .deltapos-cart-dropdown-item-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: .35s;
  }
}


.scroll-area--customizer {
  position: relative;
  margin: auto;
  width: 100%;
  height: 2950px;
}
</style>
